import { Tabs, Tab, Button, Chip, Popover, PopoverContent,Autocomplete,AutocompleteItem ,PopoverTrigger, } from "@nextui-org/react"
import { MainContainer } from "../../components/index.js"
import DashboardChart from "./DashboardChart.jsx"
import DashboardPurchase from "./DashboardPurchase.jsx"
import DashboardSale from "./DashboardSale.jsx"
import DashboardOutstanding from "./DashboardOutstanding.jsx"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import dayjs from "dayjs"
import { apiRoute, ENUM_ENCRYPT_CODE, linksUrl } from "../../constants/enum.js"
import { isMobile } from "react-device-detect"
import { toast } from "react-toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendar, faCalendarAlt, faCalendarDays, faCalendarXmark, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons"
import { useFetchWithBody } from "../../api/reactQueryCustomHooks.jsx"
import Temp from "./newdash/Temp.jsx"



function Dashboard() {
  const { rcid } = useParams();
  const [isDateDisable, setIsDateDisable] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState("")

  const { compCode, yearId, isReload, startDate, endDate } = useSelector((state) => state.company)
  const [filterDate, setFilterDate] = useState({
    start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
    end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
  })
  const [propsDate, setPropsDate] = useState({
    start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
    end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
  })
  const { data: unitMaster = [] } = useFetchWithBody({
    url: apiRoute.report.invoice.getUnit,
    queryKey: "Fetch Unit data",
    inputData: {
      compcode: compCode.join(",")
    }
  })
  let tabs = [
    {
      id: "chart",
      label: "Chart",
      content: <DashboardChart propDate={propsDate} propUnit={selectedUnit} />,
    },
    {
      id: "purchase",
      label: "Purchase",
      content: <DashboardPurchase propDate={propsDate} propUnit={selectedUnit} />,
    },
    {
      id: "sale",
      label: "Sale",
      content: <DashboardSale propDate={propsDate} propUnit={selectedUnit} />,
    },
    {
      id: "outstanding",
      label: "Outstanding",
      content: <DashboardOutstanding />,
    },
  ]

  //set payable recevable when click from main dashboard
  let isRedFrmDsbMst = ""
  if (rcid == ENUM_ENCRYPT_CODE.payable || rcid == ENUM_ENCRYPT_CODE.receivable || rcid == ENUM_ENCRYPT_CODE.difference
    || rcid == ENUM_ENCRYPT_CODE.purchase || rcid == ENUM_ENCRYPT_CODE.sale
  )
    isRedFrmDsbMst = rcid ?? ""

  const outPData = useSelector((state) => state.outstandingPayable)
  const outRData = useSelector((state) => state.outstandingReceivable)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterDate(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleReset = () => {
    setFilterDate({
      start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
      end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
    })
    setPropsDate({
      start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
      end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
    })

  }
  const handleBtnClick = () => {
    let error = ""
    const start = dayjs(filterDate.end)
    const end = dayjs(filterDate.start)
    const months = start.diff(end, 'month');
    const t_year = dayjs(startDate).format('YYYY')
    const minDate = t_year - 2 + "-" + dayjs(startDate).format('MM') + "-" + dayjs(startDate).format('DD')

    if (!dayjs(filterDate.start).isValid || !dayjs(filterDate.end).isValid ||
      filterDate.start == "Invalid date" || filterDate.end == "Invalid Date" ||
      filterDate.start == null || filterDate.end == null) {
      toast.error("Inavlid Start / End Date ", {
        "position": "top-center"
      })

    }
    else {
      if (dayjs(filterDate.start).isValid && dayjs(filterDate.end).isValid) {
        if ((dayjs(filterDate.end).format("YYYY-MM-DD") < dayjs(minDate).format("YYYY-MM-DD")) ||
          (dayjs(filterDate.start).format("YYYY-MM-DD") < dayjs(minDate).format("YYYY-MM-DD"))) {

          error += `Start / End Date must not be less than ${dayjs(minDate).format("DD-MM-YYYY")},`

        }
      }
      if (dayjs(filterDate.end).isValid && dayjs(filterDate.start).isValid) {
        if ((dayjs(filterDate.end).format("YYYY-MM-DD") > dayjs(endDate).format("YYYY-MM-DD")) ||
          (dayjs(filterDate.start).format("YYYY-MM-DD") > dayjs(endDate).format("YYYY-MM-DD"))) {

          error += `Start / End Date must not be greater than ${dayjs(endDate).format("DD-MM-YYYY")},`

        }
      }
    }
    if (months > 12) error += "Date period must not be greater than 1 year,"
    if (error == "") {
      //console.log(filterDate)
      setPropsDate(filterDate)
    }
    else {
      const messages = error.split(',');
      toast.error(
        <div>
          {messages.map((msg, idx) => msg != "" ? (

            <div key={idx} className="p-1">
              <FontAwesomeIcon className="mr-2" icon={faExclamationTriangle} ></FontAwesomeIcon>
              {msg.trim()}</div> // Trim to remove extra spaces
          ) : "")}
        </div>,
        {
          position: "top-center",
          icon: false,
          style: { whiteSpace: 'pre-line', width: '400px', fontSize: "0.8rem", color: "#da3333ff" }, // Optional here, mostly needed if using \n
        }
      );
    }
    //e.preventDefault();

  }
  const handleTabChange = (val) => {
    
    if (val == "outstanding") {
      setIsDateDisable(true)
    }
    else
      setIsDateDisable(false)
  }
  return (
    <div>
      <MainContainer pageName="Trading Dashboard">
        <div>
          {isDateDisable ? "" :
            <div className="flex justify-end  flex-wrap items-center gap-2">
               <Autocomplete
            size="sm"
            label={""}
            color="danger"
            eventResizeFeature={true}
            selectionMode="single"
            showScrollIndicators={true}
            placeholder={"--SELECT UNIT--"}
            className="w-60 font-semibold text-sm"
            classNames={{ "label": "font-semibold" }}
             labelPlacement="outside"
            isClearable={true}
            variant="flat"
            isVirtualized
            defaultItems={
              unitMaster || []
            }
            onSelectionChange={setSelectedUnit}
            selectedKey={selectedUnit}
          >
            {(list) => (
              <AutocompleteItem

                key={list.Party_Id}
              >
                {list.Party_Name}
              </AutocompleteItem>
            )}
          </Autocomplete>
              <div className="flex gap-2">
                <Chip variant="bordered" className="border-1 border-pink-500" size="sm" color="danger" > From : {dayjs(filterDate.start).format("DD-MMM-YYYY")}</Chip>
                <Chip variant="bordered" className="border-1 border-pink-500" size="sm" color="danger" > To : {dayjs(filterDate.end).format("DD-MMM-YYYY")}</Chip>
              </div>                    {/* date */}

              <Popover placement="bottom" variant="bordered"
                //isDismissable={false}
                shouldCloseOnBlur={false}
                shouldBlockScroll={true}
                shouldCloseOnScroll={false}
                showArrow={true}>
                <PopoverTrigger>
                  <Button size="sm"
                    className="bg-sky-200  text-md border-2 border-sky-500 text-sky-600 px-1" isIconOnly={true}   >
                    <FontAwesomeIcon className="text-xl" icon={faCalendarDays}></FontAwesomeIcon>
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="z-[1000]">
                  <div
                    onMouseDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                  >
                    {/* <form onSubmit={handleBtnClick} > */}
                    <div className={`${isMobile ? 'flex-wrap justify-center' : ''} flex gap-2 p-4`}>
                      <div className={`flex  gap-2 `}>

                        <div className="relative">
                          <input
                            type="date"
                            name="start"
                            value={filterDate.start}
                            onChange={handleChange}
                            required
                            className="block w-full p-1 text-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                          />

                        </div>
                        <div className="relative">
                          <input
                            type="date"
                            name="end"
                            value={filterDate.end}
                            onChange={handleChange}
                            required
                            className="block w-full p-1  text-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                          />

                        </div>
                      </div>
                      <div className={`flex  gap-2 `}>
                        <Button size="sm" variant="shadow" className="bg-blue-700 h-7 text-white" onPress={handleBtnClick} >Apply</Button>
                        <Button size="sm" color="danger" variant="shadow" className=" h-7 text-white" onPress={handleReset} >Reset</Button>
                      </div>
                    </div>
                    {/* </form> */}
                  </div>
                </PopoverContent>
              </Popover>

            </div>
          }
         
        </div>
        <div className="flex w-full flex-col">
 {/* <Temp/>  */}
          <Tabs aria-label="Dynamic tabs" color="primary" items={tabs} radius="none" className="font-semibold  text-sm"
            onSelectionChange={handleTabChange}
            defaultSelectedKey={(outPData && outPData.isFromDashboard) || (outRData && outRData?.isFromDashboard) ||
              (isRedFrmDsbMst && (isRedFrmDsbMst == ENUM_ENCRYPT_CODE.receivable ||
                isRedFrmDsbMst == ENUM_ENCRYPT_CODE.payable)
              ) ? "outstanding"
              : isRedFrmDsbMst && rcid == ENUM_ENCRYPT_CODE.sale ? "sale"
                : isRedFrmDsbMst && rcid == ENUM_ENCRYPT_CODE.purchase ? "purchase"
                  : ""}
          >
            {(item) => (
              <Tab className="text-sm " key={item.id} title={item.label}   >

                {item.content}

              </Tab>
            )}
          </Tabs>

        </div>
      </MainContainer>
    </div>
  )
}
export default Dashboard
